import Http from "./http-service";

import { PRIVATE_API_ROUTES } from "../constants";
import { showNotification } from "../UtilityFunctions/notification";
import { getLocalizedMessage } from "../UtilityFunctions/utils";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";

class MediaService {
  static async uploadMedia({ loaderDispatch, body, queryParams, intl }) {
    let url = PRIVATE_API_ROUTES.UPLOAD_MEDIA + `?type=${queryParams.type}`;
    if (queryParams.auditId) {
      url += `&auditId=${queryParams.auditId}`;
    }

    if (queryParams.questionId) {
      url += `&questionId=${queryParams.questionId}`;
    }

    loaderDispatch(setLoading(true));
    return Http.post(url, body)
      .then((response) => {
        loaderDispatch(setLoading(false));
        return Promise.resolve(response);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }
  static async uploadMultipartMedia({ body, queryParams, intl }) {
    let url =
      PRIVATE_API_ROUTES.UPLOAD_MEDIA_MULTIPART + `?type=${queryParams.type}`;
    if (queryParams.auditId) {
      url += `&auditId=${queryParams.auditId}`;
    }

    if (queryParams.questionId) {
      url += `&questionId=${queryParams.questionId}`;
    }

    if (queryParams.status) {
      url += `&status=${queryParams.status}`;
    }

    if (queryParams.documentId) {
      url += `&documentId=${queryParams.documentId}`;
    }

    return Http.post(url, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }
  static async deleteMediaData({ loaderDispatch, mediaId, intl, params }) {
    loaderDispatch(setLoading(true));
    return Http.delete(
      `${PRIVATE_API_ROUTES.UPLOAD_MEDIA}/${mediaId}?auditResponseId=${params.responseId}&auditId=${params.auditId}`
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }

  static async getMediaData({ loaderDispatch, mediaId, intl }) {
    if (loaderDispatch) loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.UPLOAD_MEDIA}/${mediaId}?download=false`,
      null,
      () => {}, //NOSONAR
      "blob"
    )
      .then((res) => {
        if (loaderDispatch) loaderDispatch(setLoading(false));
        return Promise.resolve(res);
      })
      .catch((err) => {
        if (loaderDispatch) loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(
            intl,
            err.response.request.status === 403
              ? "error.evidenceInProgressViaTwilio"
              : "error.somethingWentWrong"
          )
        );
        return Promise.reject(err);
      });
  }
}

export default MediaService;
